import { reactive } from "vue";
export const stateSymbol = Symbol("state");
export const createState = reactive({
  // brokerip:'192.168.2.230',
  // brokerip:'192.168.24.95',
  // brokerip:'127.0.0.1',
  brokerip: "47.105.73.79",
  projectTopic: "", //具体项目topic
  topicType: false, //控制是否进行跳转 ranking页面选择其他阶段时使用
  matchTopic: "NSSP0001/CompetitionListFlat",
  matchesList: [], // 比赛列表（去重后，用于下拉选择）
  matchList: [], //所以线上比赛信息
  selectedMatchId: "", //比赛id
  matchInfo: "", //比赛信息
  projectInfo: {}, //项目信息
  menuList: [], //比赛列表
  groupList: [], //组别列表
  projectList: [], //项目列表
  client: {},
  svgComponentName: "", //svgname 用于展示靶面
  showList: [], //成绩展示list
  propshowData: [], //ranking页面侧滑项目list
  show: false, //侧滑开关
  active: 0, //组别切换
  ProActive: 0, //项目切换
  pdfmatchList: [], //pdf比赛列表
  pdfprojectList: [], //pdf项目列表
  showYear: [], //默认展示年份
});
